import IssuesTable from './IssuesTable';
import { Stack } from '@mui/material';
import { useCallback, useState } from 'react';
import IssuesFilters, { IssuesFiltersType, getFiltersInitialState } from './IssuesFilters';
import { SearchInput } from '../common/SearchInput';
import { filterItemsBySearch } from '../../lib/filterItemsBySearch';
import { Issue } from './issuesTypes';
import { OnUpdateIssueStatus } from '../aiAgentCenter/aiAgentsConsts';
import { ActiveScan, ScanStatus } from '@server/issues';
import ScanningIndicator from './ScanningIndicator';

const IssuesTableWithFilters = ({
  onUpdateIssueStatus,
  issues,
  activeScan,
  onTextSelection,
}: {
  onUpdateIssueStatus: OnUpdateIssueStatus;
  issues: Issue[];
  activeScan?: ActiveScan;
  onTextSelection?: (text: string | null) => void;
}) => {
  const [filters, setFilters] = useState<IssuesFiltersType>(getFiltersInitialState());
  const [search, setSearch] = useState('');

  const filteredIssues = issues.filter((issue: Issue) => {
    const bySeverity =
      filters.selectedSeverity.length > 0
        ? filters.selectedSeverity.includes(issue.severity)
        : true;
    const byType =
      filters.selectedConfigurationTypes.length > 0
        ? filters.selectedConfigurationTypes.includes(issue.resourceType)
        : true;
    const byIssue =
      filters.selectedIssues.length > 0
        ? filters.selectedIssues.includes(issue.bestPracticeName)
        : true;
    const byStatus =
      filters.selectedStatus.length > 0 ? filters.selectedStatus.includes(issue.status) : true;
    return byType && bySeverity && byIssue && byStatus;
  });

  const itemsToRender = filterItemsBySearch<Issue>(filteredIssues, search, 'resourceName');

  const setFilter = useCallback((partialFilters: Partial<IssuesFiltersType>) => {
    setFilters((prev) => ({ ...prev, ...partialFilters }));
  }, []);

  const searchJsx = (
    <SearchInput
      TextFieldProps={{
        value: search,
        placeholder: 'Search',
        onChange: (e) => {
          setSearch(e.target.value);
        },
      }}
      withFixedMagnifyingGlassIcon={true}
      onClearButtonClick={() => setSearch('')}
      size="small"
    />
  );

  const isScanInProgress = activeScan && activeScan?.status !== ScanStatus.DONE;

  return (
    <Stack gap={2} sx={{ height: '100%', overflow: 'hidden' }}>
      {isScanInProgress && <ScanningIndicator />}
      <Stack gap={2} sx={{ height: '100%', overflow: 'hidden' }}>
        <IssuesFilters
          issues={issues}
          filters={filters}
          setFilter={setFilter}
          searchJsx={searchJsx}
        />
        <IssuesTable
          issues={itemsToRender}
          onUpdateIssueStatus={onUpdateIssueStatus}
          onTextSelection={onTextSelection}
        />
      </Stack>
    </Stack>
  );
};

export default IssuesTableWithFilters;
